module.exports = __webpack_public_path__ + "static/media/teacher-img-mob.e224c0c6.png";